import { FieldTests } from "restaumatic-client";
import { historicalFulfillmentTime } from "./experiments/historicalFulfillmentTime";
/**
 * This divides sites into groups that can be used in experiments.
 * Good practices:
 * - assign only one experiment to the group
 * - groups should not overlap
 */
export const siteGroups = {
    even: (siteId) => siteId % 2 === 0,
    odd: (siteId) => siteId % 2 !== 0,
};
/**
 * Global instance for initialising and getting experiments' data.
 */
const fieldTest = new FieldTests();
export default {
    init() {
        var _a, _b;
        fieldTest.setDeviceType((_b = (_a = Skubacz === null || Skubacz === void 0 ? void 0 : Skubacz.Device) === null || _a === void 0 ? void 0 : _a.getDeviceType()) !== null && _b !== void 0 ? _b : "");
        fieldTest.applyExperiments([]);
        fieldTest.cleanUpAfterOtherTestsThan([historicalFulfillmentTime]);
    },
    getVariant(experiment) {
        return fieldTest.getVariant(experiment);
    },
    apply(experiment) {
        fieldTest.applyExperiments([experiment]);
    },
};
